import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("g360_user") || "null");
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const persist = (token, u) => {
    localStorage.setItem("g360_token", token);
    localStorage.setItem("g360_user", JSON.stringify(u));
    setUser(u);
  };

  const login = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      persist(data.access_token, data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", payload);
      persist(data.access_token, data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("g360_token");
    localStorage.removeItem("g360_user");
    setUser(null);
  };

  const refreshMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("g360_user", JSON.stringify(data));
      setUser(data);
    } catch {
      logout();
    }
  };

  useEffect(() => {
    const t = localStorage.getItem("g360_token");
    if (t && user) refreshMe();
    // eslint-disable-next-line
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
